import Breakfast from "../assets/images/Breakfast.jpg";
import Lunch from "../assets/images/lunch.jpg";
import Dinner from "../assets/images/dessert.jpg";
import Starters from "../assets/images/breakfast1.jpg";
import Combo from "../assets/images/Logoimage.jpg";
import Grills from "../assets/images/lunch1.jpg";

export const MenuList = [
  {
    name: "Breakfast",
    image: Breakfast,
    price: 2500,
  },
  {
    name: "Lunch",
    image: Lunch,
    price: 7000,
  },
  {
    name: "Dinner",
    image: Dinner,
    price: 5800,
  },
  {
    name: "Starters",
    image: Starters,
    price: 4000,
  },
  {
    name: "Combo",
    image: Combo,
    price: 6000,
  },
  {
    name: "Grills",
    image: Grills,
    price: 5500,
  },
];
